import { __assign } from "tslib";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { BiEventType, BiDataHook } from '@wix/da-bi/pkg/constants';
import Download from '@wix/da-ds/pkg/Icons/24x24/Download';
import ActionBarIcon from '../../../_partials/ActionBarIcon';
import ActionBarItemWrapper from '../../../_partials/items/ActionBarItemWrapper';
import ActionBarLink from '../../../_partials/items/ActionBarLink';
import ActionBarButton from '../../../_partials/items/ActionBarButton';
var FreeDownloadLink = function (props) {
    var _a = props.deviation, deviationId = _a.deviationId, _b = _a.extended, _c = _b === void 0 ? {} : _b, download = _c.download, isLoggedIn = props.isLoggedIn, restrictLoggedOut = props.restrictLoggedOut, onDownload = props.onDownload, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, iconRef = props.iconRef;
    var t = useTranslation().t;
    if (!download) {
        return null;
    }
    var biProps = {
        biData: {
            evid: BiEventType.CLICK_DOWNLOAD_BUTTON,
            deviationid: deviationId,
            ispaiddownload: 0,
        },
        'data-hook': BiDataHook.DEVIATION_DOWNLOAD_BUTTON,
    };
    return (React.createElement(ActionBarItemWrapper, { tooltip: t('actionbar.download') }, isLoggedIn ? (React.createElement(ActionBarLink, __assign({ href: download.url, download: true, target: "_blank", onClick: onDownload, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave }, biProps),
        React.createElement(ActionBarIcon, { icon: Download, iconRef: iconRef }))) : (React.createElement(ActionBarButton, __assign({ onClick: restrictLoggedOut }, biProps),
        React.createElement(ActionBarIcon, { icon: Download, iconRef: iconRef })))));
};
FreeDownloadLink.displayName = 'FreeDownloadLink';
export default FreeDownloadLink;
//# sourceMappingURL=FreeDownloadLink.js.map